import React, { useMemo } from 'react';
import NotesEditor from '../../../../shared/Notes/NotesEditor';
import { NotesTabNavigationParamList, useGoBack, useNotesTabNavigation } from '../../../../../utils/appNavigationNames';
import { useEditNote } from '../../../../../hooks/api/useNotes';
import { RouteProp } from '@react-navigation/native';
import { NoteDestination, noteDetailsToDestination } from '../../../../shared/Notes/utils/types';
import { useConfirmBackNavigationOnDirtyForm } from '../../../../shared/FormExitValidation';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { View } from 'react-native';

export type NoteEditScreenOwnProps = {};

export type NoteEditScreenProps = NoteEditScreenOwnProps & { route: RouteProp<NotesTabNavigationParamList, 'edit'> };

const NoteEditScreen: React.FC<NoteEditScreenProps> = (props) => {
    const goBack = useGoBack();
    const navigator = useNotesTabNavigation();
    useConfirmBackNavigationOnDirtyForm(navigator);
    const { note, isLoadingNote, isUpdatingUserNote, noteEditorProps, key } = useEditNote({
        noteId: props.route.params.noteId,
        onUpdateSuccess: () => {
            goBack();
        },
    });

    const noteDestination = useMemo<NoteDestination | null>(
        () => (note ? noteDetailsToDestination(note) : null),
        [note],
    );

    return (
        <AnimateLoadedContent isLoading={!note || isLoadingNote || !noteDestination || isUpdatingUserNote}>
            {() => (
                <View style={{ width: '100%', height: '100%' }}>
                    <NotesEditor
                        key={key}
                        source="notes.edit-note-route"
                        onCancel={goBack}
                        note={note!}
                        noteDestination={noteDestination!}
                        defaultTab={props.route.params.defaultTab}
                        disableRecording
                        {...noteEditorProps}
                    />
                </View>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(NoteEditScreen);
